<div class="auth-wrapper auth-v2">
  <div class="auth-inner row m-0">
    <!-- Brand logo--><a class="brand-logo" href="javascript:void(0);">
      <img src="{{ coreConfig.app.appLogoImage }}" alt="brand-logo" height="28" />
      <h2 class="brand-text text-primary ml-1">Vuexy</h2></a
    >
    <!-- /Brand logo-->
    <!-- Left Text-->
    <div class="d-none d-lg-flex col-lg-8 align-items-center p-5">
      <div class="w-100 d-lg-flex align-items-center justify-content-center px-5">
        <img
          class="img-fluid"
          [src]="
            coreConfig.layout.skin === 'dark'
              ? 'assets/images/pages/forgot-password-v2-dark.svg'
              : 'assets/images/pages/forgot-password-v2.svg'
          "
          alt="Forgot password V2"
        />
      </div>
    </div>
    <!-- /Left Text-->
    <!-- Forgot password-->
    <div class="d-flex col-lg-4 align-items-center auth-bg px-2 p-lg-5">
      <div class="col-12 col-sm-8 col-md-6 col-lg-12 px-xl-2 mx-auto">
        <h2 class="card-title font-weight-bold mb-1">Forgot Password? 🔒</h2>
        <p class="card-text mb-2">Enter your email and we'll send you instructions to reset your password</p>
        <form class="auth-forgot-password-form mt-2" [formGroup]="forgotPasswordForm" (ngSubmit)="onSubmit()">
          <div class="form-group">
            <label class="form-label" for="forgot-password-email">Email</label>
            <input
              class="form-control"
              type="text"
              formControlName="email"
              placeholder="john@example.com"
              aria-describedby="forgot-password-email"
              autofocus=""
              tabindex="1"
              [ngClass]="{ 'is-invalid': submitted && f.email.errors }"
            />
            <div *ngIf="submitted && f.email.errors" class="invalid-feedback">
              <div *ngIf="f.email.errors.required">Email is required</div>
              <div *ngIf="f.email.errors.email">Email must be a valid email address</div>
            </div>
          </div>
          <button class="btn btn-primary btn-block" tabindex="2" rippleEffect>Send reset link</button>
        </form>
        <p class="text-center mt-2">
          <a routerLink="/pages/authentication/login-v2"
            ><i data-feather="chevron-left" class="mb-25"></i> Back to login</a
          >
        </p>
      </div>
    </div>
    <!-- /Forgot password-->
  </div>
</div>
